import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../../../v2-theme.css';

/**
 * V2Header Component
 *
 * Universal header matching HTML design
 * Shows logo, title, user info, and navigation buttons
 *
 * @param {string} title - Site title (default: "Hands On The Fly")
 * @param {string} userName - Logged-in user's name
 * @param {string} businessName - Business name (for restaurant users)
 * @param {string} userType - 'worker' | 'restaurant' | 'admin'
 * @param {boolean} showProfileLink - Whether to show profile link
 * @param {string} profilePath - Path to profile page
 * @param {function} onLogout - Logout handler
 */
const V2Header = ({
  title = 'Hands On The Fly',
  userName,
  businessName,
  userType = 'worker',
  showProfileLink = true,
  profilePath,
  onLogout,
  ...props
}) => {
  const navigate = useNavigate();

  const handleProfileClick = () => {
    if (profilePath) {
      navigate(profilePath);
    } else {
      // Default profile paths based on user type
      const defaultPaths = {
        worker: '/profile/worker',
        restaurant: '/profile/restaurant',
        admin: '/admin/dashboard'
      };
      navigate(defaultPaths[userType] || '/');
    }
  };

  const handleLogout = () => {
    if (onLogout) {
      onLogout();
    } else {
      // Default logout behavior
      navigate('/');
    }
  };

  const displayName = businessName || userName;

  return (
    <header className="v2-header">
      <div className="v2-header-content">
        <div className="v2-logo-title">
          <img
            src="/hotf-web-icon.png"
            alt="Hands On The Fly"
            className="v2-logo"
          />
          <h1 className="v2-title">{title}</h1>
        </div>
        <div className="v2-header-nav">
          {displayName && (
            <span className="v2-user-name">{displayName}</span>
          )}
          {showProfileLink && (
            <button
              className="v2-logout-btn"
              onClick={handleProfileClick}
            >
              Profile
            </button>
          )}
          <button
            className="v2-logout-btn"
            onClick={handleLogout}
          >
            Logout
          </button>
        </div>
      </div>
    </header>
  );
};

export default V2Header;
